















































import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "BaseSpinner",
  props: {
    strokeWidth: { type: Number, default: 6 },
    linePercentFill: { type: Number as () => number | undefined },
    color: { type: String },
    insideColor: { type: String },
    autoFillTimeout: { type: Number, default: 0 },
    size: { type: [String, Number], default: "35px" },
    id: {
      type: String,
      default: () =>
        Math.random()
          .toString(36)
          .substring(2, 15),
    },
  },
});
